import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, ResponseContentType } from "@angular/http";
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map';

import { BrogliaccioDistintaModel } from '../models/brogliacci/brogliaccio-distinta.model';
import { Configurations } from "../core/configurations";
import { BrogliaccioSearchModel } from "../models/brogliacci/brogliaccio-search.model";
import { environment } from "../../environments/environment";
import { DizionarioModel } from "../models/shared/dizionario.model";
import { IncassoModel } from "../models/incassi/incasso.model";
import { LocalDb } from "../core/localdb";
import { newId, guid } from "../core/utilities";
import {BancheItemsModel} from "../models/brogliacci/banche.model";
import {AuthService} from "./auth.service";
import { NotificationModel } from '../models/shared/notificationModel.model';
const DISTINTE_API: string = 'assets/mock-data/distinteversamenti';

@Injectable()
export class DistinteVersamentiService {

  APIDistinteVersamento = this.configuration.apiBaseUrlDistinteVersamento;
  apiBaseUrlStampe = this.configuration.apiBaseUrlStampe;
  APIStatiDistinta = this.configuration.apiBaseUrlStatiDistinte + "distinteVersamenti";
  MethodLista = `listaDistinteVersamenti`;
  MethodVerifica = "verifica";
  MethodChiusura = "chiusura";
  MethodPrint = "print";
  MethodUpload = "upload";
  MethodDownload = "download";
  MethodBanche= "listaBanche";
  constructor(private http: Http, private configuration: Configurations, private authenticationService: AuthService) { }

  /*
  1- elenco delle distinte (ricerca distinte versamenti)
  2- get specifica distinta
  3- salvataggio nuova distinta
  4- get lista stati distinta
  5- conferma distinta
  6- elimina distinta
  7- banche
  8- chiudi distinta (versamento in banca)
  9- stampa
  10- Get image 
  */


  getFilteredList(model: BrogliaccioSearchModel): Observable<BrogliaccioDistintaModel[]> {

    let searchParams = model || new BrogliaccioSearchModel();
    let url = this.APIDistinteVersamento + this.MethodLista;
    return this.http.post(url, searchParams)
      .map((r: Response) => r.json() as BrogliaccioDistintaModel[])
      .catch((r:any)=> {
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        Observable.throw(r.json().error || 'Server error');
      });

  }


  get(gid: string): Observable<BrogliaccioDistintaModel> {

    return this.http.get(this.APIDistinteVersamento + '/' + gid)
      .map((r: Response) => r.json() as BrogliaccioDistintaModel)
      .catch((r:any)=> {
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        Observable.throw(r.json().error || 'Server error');
      });

  }


  insert(lista: string[]): Observable<Response> {

    return this.http.post(this.APIDistinteVersamento, lista)
      .map(res => { 
        return res.json(); })
      .catch((r:any)=> {
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        Observable.throw(r.json().error || 'Server error');
      });

  }

  getStati(): Observable<DizionarioModel[]> {

    let url = this.APIStatiDistinta;
    return this.http.get(url)
      .map((r: Response) => r.json() as DizionarioModel[])
      .catch((r:any)=> {
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        Observable.throw(r.json().error || 'Server error');
      });

  }


  stampaDistinta(token: string): Observable<Blob> {

    let url = this.apiBaseUrlStampe;
    return this.http.get(url + this.MethodPrint + "/" + token)
      .map(res => new Blob([res])).catch((r:any)=> {
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        Observable.throw(r.json().error || 'Server error');
      });
  }


  getBanche(): Observable<BancheItemsModel[]> {
    
        let url = this.APIDistinteVersamento+this.MethodBanche;
        return this.http.get(url)
          .map((r: Response) => r.json() as BancheItemsModel[])
          .catch((r:any)=> {
            if(r.status===401) {
              this.authenticationService.logoutIfSessionExpired().subscribe(
                (res:any)=> {
      
                });
              return Observable.throw("Autorizzazione negata.");
            }
            Observable.throw(r.json().error || 'Server error');
          });
    
      }

  
  //verificata (confermata)
  confermaDistintaVersamenti(model: BrogliaccioDistintaModel): Observable<NotificationModel> {

    let url = this.APIDistinteVersamento + this.MethodVerifica + '/' + model.token;
    return this.http.put(url, null).map(res => { 
      return res.json() as NotificationModel; })
    .catch((r:any)=> {
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      Observable.throw(r.json().error || 'Server error');
    });
  }

  uploadDocumentoVersamento(formData: FormData, model: BrogliaccioDistintaModel): Observable<Response> {

    let url = this.APIDistinteVersamento + this.MethodUpload;
    return this.http.post(url, formData)
      .map(res => { 
        return res.json(); })
      .catch((r:any)=> {
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        Observable.throw(r.json().error || 'Server error');
      });
  }

  //chiusura distinta con dati del versamento in banca
  chiudiDistintaVersamenti(model: BrogliaccioDistintaModel): Observable<NotificationModel> {
    let url = this.APIDistinteVersamento + this.MethodChiusura;// + '/' + model.token;
    return this.http.post(url, model)
      .map(res => { 
        return res.json() as NotificationModel; })
      .catch((r:any)=> {
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        Observable.throw(r.json().error || 'Server error');
      });
  }

  eliminaDistinta(model: BrogliaccioDistintaModel): Observable<Response> {

    let url = this.APIDistinteVersamento;
    return this.http.delete(url + model.token)
      .map((r: Response) => { 
        return r.json(); })
      .catch((r:any)=> {
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        Observable.throw(r.json().error || 'Server error');
      });

  }

  getFileImage(token: string): Observable<Blob> {
    let url = this.APIDistinteVersamento + this.MethodDownload + "/" + token;
    return this.http
      .get(url, { responseType: ResponseContentType.Blob })
      .map((res: Response) => res.blob()).catch((r:any)=> {
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        Observable.throw(r.json().error || 'Server error');
      });
  }

  //non usato
  update(model: BrogliaccioDistintaModel): Observable<BrogliaccioDistintaModel> {

    let url = this.APIDistinteVersamento;
    return this.http.put(url, null).map(res => { res.json(); return Observable.of(true); }).catch((r:any)=> {
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      Observable.throw(r.json().error || 'Server error');
    });

  }
}


/* DATA */

//OLD
/*
const _DISTINTEVERSAMENTI: BrogliaccioDistintaModel[] = [];
const STATI_DISTINTA: DizionarioModel[] = [
  { id: 1, codice: "L", descrizione: 'Lavorazione' },
  { id: 2, codice: "V", descrizione: 'Verificata' },
  { id: 3, codice: "C", descrizione: 'Chiusa' }
];*/


const BANCHE: DizionarioModel[] = [
  { id: 1, codice: "", descrizione: 'Banca A' },
  { id: 2, codice: "", descrizione: 'Banca B' },
  { id: 3, codice: "", descrizione: 'Banca C' }
];



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/services/distinte-versamenti.service.ts